import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { SpecialEquipment } from '../models/models';

import { InfrastructureService } from './infrastructure.service';

@Injectable({
  providedIn: 'root',
})
export class SpecialEquipmentService extends InfrastructureService<SpecialEquipment> {
  protected readonly endpoint: string = '/SpecialEquipment';

  constructor(protected http: HttpClient) {
    super(http);
  }

}
